// /home/labdoo/zitech-nexus/frontend/src/pages/Profile.tsx
import React, { useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import './Profile.css';

// SVG Icons
const Icons = {
  User: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Email: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Phone: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  Company: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Calendar: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Edit: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Save: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Cancel: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Camera: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="pr-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
};

const Profile: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    phone_number: '',
    company_name: '',
  });

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setUser(userData);
      setFormData({
        full_name: userData.full_name || '',
        phone_number: userData.phone_number || '',
        company_name: userData.company_name || '',
      });
    }
    setLoading(false);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await authAPI.updateProfile(formData);
      const updatedUser = { ...user, ...formData };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      setUser(updatedUser);
      setEditing(false);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile');
    }
  };

  if (loading) {
    return (
      <div className="pr-loading-container">
        <div className="pr-spinner">
          <Icons.Spinner />
        </div>
        <p className="pr-loading-text">Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="pr-container">
      {/* Header */}
      <div className="pr-header">
        <h1 className="pr-title">Profile Settings</h1>
        <p className="pr-subtitle">Manage your personal information</p>
      </div>

      {/* Content */}
      <div className="pr-content">
        {/* Avatar Section */}
        <div className="pr-avatar-card">
          <div className="pr-avatar">
            {user?.full_name?.charAt(0) || user?.username?.charAt(0) || 'U'}
          </div>
          <button className="pr-avatar-btn">
            <Icons.Camera />
            Change Avatar
          </button>
        </div>

        {/* Form Section */}
        <div className="pr-form-card">
          {!editing ? (
            <div className="pr-info">
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.User />
                  Full Name
                </span>
                <span className="pr-info-value">{user?.full_name || 'Not set'}</span>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.Email />
                  Email
                </span>
                <span className="pr-info-value">{user?.email}</span>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.Phone />
                  Phone Number
                </span>
                <span className="pr-info-value">{user?.phone_number || 'Not set'}</span>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.Company />
                  Company Name
                </span>
                <span className="pr-info-value">{user?.company_name || 'Not set'}</span>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.User />
                  Username
                </span>
                <span className="pr-info-value">{user?.username}</span>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">
                  <Icons.Calendar />
                  Member Since
                </span>
                <span className="pr-info-value">
                  {user?.date_joined ? new Date(user.date_joined).toLocaleDateString('en-US', { 
                    month: 'long', 
                    day: 'numeric', 
                    year: 'numeric' 
                  }) : 'N/A'}
                </span>
              </div>
              <button className="pr-edit-btn" onClick={() => setEditing(true)}>
                <Icons.Edit />
                Edit Profile
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="pr-form">
              <div className="pr-form-group">
                <label className="pr-form-label">Full Name</label>
                <input
                  type="text"
                  name="full_name"
                  className="pr-form-input"
                  value={formData.full_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="pr-form-group">
                <label className="pr-form-label">Phone Number</label>
                <input
                  type="tel"
                  name="phone_number"
                  className="pr-form-input"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="pr-form-group">
                <label className="pr-form-label">Company Name</label>
                <input
                  type="text"
                  name="company_name"
                  className="pr-form-input"
                  value={formData.company_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="pr-form-actions">
                <button type="button" className="pr-btn-cancel" onClick={() => setEditing(false)}>
                  <Icons.Cancel />
                  Cancel
                </button>
                <button type="submit" className="pr-btn-save">
                  <Icons.Save />
                  Save Changes
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;